import { resetCart, setCartZipcode } from "../../features/cart/cartSlice";
import { resetCustomer } from "../../features/customer/customerSlice";
import { loadGeneralOptions, selectIsMobileRoute, setIsMobileNavToggled } from "../../features/mobile/mobileSlice";
import { resetReferrals } from "../../features/referrals/referralsSlice";
import { setAuthInfo } from "../../features/user/userSlice";
import { resetOrderPlannerOrders } from "../../pages/AutoshipPages/core/orderPlannerOrdersSlice";
import { persistor, store } from "../store";

export async function handleResponse(response: Response): Promise<any> {
  let json: any;
  const state = store.getState();
  const AppURL = selectIsMobileRoute(state);
  const QURLParams = AppURL ? `/?${AppURL}` : "/";

  try {
    json = await response.json();
  } catch {
    throw new Error(`HTTP error. status: ${response.status}`);
  }

  if (
    !response.ok &&
    (json?.detail === "Forbidden" ||
    json?.detail === "Not Found")
  ) {
    localStorage.removeItem('usertoken');
    localStorage.removeItem('userAuthInfo');
    localStorage.removeItem('profileImage');
    store.dispatch(setAuthInfo({
      token: '',
      email: '',
      nicename: '',
      display_name: ''
    }));
    store.dispatch(setIsMobileNavToggled(false));
    store.dispatch({ type: "USER_LOGOUT" });
    persistor.purge();
    window.location.href = `/my-account${QURLParams}`;
    store.dispatch(resetCart());
    store.dispatch(resetReferrals());
    store.dispatch(setCartZipcode(''));
    store.dispatch(resetCustomer());
    store.dispatch(resetOrderPlannerOrders());
    store.dispatch(loadGeneralOptions());
    document.cookie = `authToken=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT; Secure; SameSite=None`;
    if ((window as any).median && (window as any).median.klaviyo) {
      (window as any).median.klaviyo.resetProfile();
    }

    throw new Error(json?.detail || `HTTP error. status: ${response.status}`);
  }

  return json;
}